




import { Component, Prop, Vue } from 'vue-property-decorator';

import { Chart } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

import { RiskAssessmentRating, ThreatWithQuestions } from '../models';

@Component
export default class RiskBreakdownChart extends Vue {
  @Prop(Map) private readonly riskAssessmentRatingMap!: Map<RiskAssessmentRating, ThreatWithQuestions[]>;

  get lowCount(): number {
    return this.riskAssessmentRatingMap.get(RiskAssessmentRating.Low)!.length;
  }

  get mediumCount(): number {
    return this.riskAssessmentRatingMap.get(RiskAssessmentRating.Medium)!.length;
  }

  get highCount(): number {
    return this.riskAssessmentRatingMap.get(RiskAssessmentRating.High)!.length;
  }

  get criticalCount(): number {
    return this.riskAssessmentRatingMap.get(RiskAssessmentRating.Critical)!.length;
  }

  private mounted() {
    this.createChart();
  }

  private createChart() {
    const canvas = this.$refs.chartCanvas as HTMLCanvasElement;
    const context = canvas.getContext('2d')!;
    const data = {
      datasets: [{
        data: [this.lowCount, this.mediumCount, this.highCount, this.criticalCount],
        backgroundColor: [
          '#16836f',
          '#fcaa39',
          '#ca3e4a',
          '#7e171e',
        ],
      }],
      labels: [
        RiskAssessmentRating.Low,
        RiskAssessmentRating.Medium,
        RiskAssessmentRating.High,
        RiskAssessmentRating.Critical,
      ],
    };
    // tslint:disable-next-line no-unused-expression
    new Chart(context, {
      plugins: [ChartDataLabels],
      type: 'pie',
      data,
      options: {
        title: {
          display: true,
          fontSize: 18,
          text: 'Risk Breakdown',
        },
        legend: {
          position: 'bottom',
        },
        plugins: {
          datalabels: {
            color: '#ffffff',
            font: {
              size: 18,
            },
          },
        },
      },
    });
  }
}
